import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IAddressFormMeta } from '@Shared/containers/form/address/AddressFormMeta';
import ContactFormUI from '@Shared/components/form/contact/ContactFormUI';

import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
  onSubmit: any,
  meta: IAddressFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const AddressFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={10}>
        {displayCustomInputs(
          meta,
          register,
          errors,
          isLoading,
          ['typeAddress', 
          'address',
          'street',
          'postcode',
          'phone1',
          'phone2',
          'city',
          'zone',
          'state',
          'fax',
        ],
        )}
      </CC.SimpleGrid>

      <CC.SimpleGrid columns={{ base:1, md:2 }} gridRowGap={4} columnGap={10} my={10}>

      <CC.Box mt="2%" as="fieldset"
      p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'}>
        <CC.Heading px={2} as={"legend"} fontSize='md'>Premier Contact</CC.Heading>
          <ContactFormUI
            meta={meta.firstContact}
            register={register}
            errors={errors}
          />
      </CC.Box>

      <CC.Box mt="2%" as="fieldset"
      p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'}>
        <CC.Heading px={2} as={"legend"} fontSize='md'>Second Contact</CC.Heading>
          <ContactFormUI
            meta={meta.secondContact}
            register={register}
            errors={errors}
          />
      </CC.Box>

      </CC.SimpleGrid>

       

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default AddressFormUI;
